module.exports = __webpack_public_path__ + "static/media/STARS.87c5bbf9.svg";